module.exports = __webpack_public_path__ + "static/media/delete.adb734b0.svg";